import { PathwayMethod } from "./PathwayMethod";

export default class SubspecialtyTraining {
    subspecialtyTrainingId: number;
    trainingProgramId: number;
    applicationId: number;
    trainingInstitutionName: string;
    isEditing: boolean;
    startDate: string;
    endDate: string;
    monthsCredit: number;
    isPartTime: boolean;
    percentTimeForPractice: number;
    practiceCertificationBoard: string;
    practiceCertificationDate: string;
    practiceLocation: string;
    practiceTime: string;
    pathwayMethod: PathwayMethod;
}

export enum AlternativePathwayPracticeOption {
    "An average of at least 17% of their post-training clinical practice time spent in the practice of NCC (at least 7 hours per week) for the past 6 years.*" = 1,
    "An average of at least 25% of their post-training clinical practice time spent in the practice of NCC (at least 10 hours per week) for the past 4 years.*" = 2,
    "An average of at least 33% of their post-training clinical practice time spent in the practice of NCC (at least 13 hours per week) for the past 3 years.*" = 3,
    "An average of at least 50% of their post-training clinical practice time spent in the practice of NCC (at least 20 hours per week) for the past 2 years.*" = 4,
    "An average of at least 25% of their total post-training professional time spent in the practice of NCC (at least 10 hours per week) for the past 4 years.**" = 5
}
